import PasswordProtectedComp from '@components/passwordProtected/passwordProtected.comp';

const PasswordProtectedPage = () => (
  <div className="flex h-full w-full items-center justify-center">
    <PasswordProtectedComp />
  </div>
);

export default PasswordProtectedPage;
